import React from 'react';
import { GrantDto } from '../../../../dtos/GrantDto';
import { useOverviewController } from './hooks/useOverviewController';
import OverviewView from './OverviewView';

interface OverviewProps {
    grantData: GrantDto;
}

export default function Overview({ grantData }: OverviewProps) {
    const ctrl = useOverviewController(grantData.id);
    return <OverviewView {...ctrl} />;
}
